import { ChannelType } from '@/shared/types/appTypes'

const searchByName = (query: string, arrayToFilter: ChannelType[]) => {
    const filteredChannels = arrayToFilter.filter(
        (channel: ChannelType) =>
            channel.name.toLowerCase().includes(query.toLowerCase()) ||
            query.toLowerCase().includes(channel.name.toLowerCase())
    )
    return filteredChannels
}

export { searchByName }
